interface StaffAvatarProps {
  firstName: string
  lastName: string
  photoUrl: string | null
}

export function StaffAvatar({ firstName, lastName, photoUrl }: StaffAvatarProps) {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className="h-9 w-9 rounded-full object-cover bg-slate-100 flex-shrink-0"
      />
    )
  }

  const initials =
    `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase() || '?'

  return (
    <div className="h-9 w-9 rounded-full bg-brand-100 text-brand-700 font-medium text-sm flex items-center justify-center flex-shrink-0">
      {initials}
    </div>
  )
}
